import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import * as actions from "../../../../../_redux/school-reports/SchoolReportsAction";
import * as uiHelpers from "../SchoolReportSectionsUIHelpers";
import { 
  getSelectRow, 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../../../../_metronic/_partials/controls";
import { useSchoolReportSectionsUIContext } from "../SchoolReportSectionsUIContext";

export function SchoolReportSectionsTable() {
  // School Report Sections UI Context
  const schoolReportSectionsUIContext = useSchoolReportSectionsUIContext();
  const schoolReportSectionsUIProps = useMemo(() => {
    return {
      ids: schoolReportSectionsUIContext.ids,
      setIds: schoolReportSectionsUIContext.setIds,
      queryParams: schoolReportSectionsUIContext.queryParams,
      setQueryParams: schoolReportSectionsUIContext.setQueryParams,
      term: schoolReportSectionsUIContext.term
    };
  }, [schoolReportSectionsUIContext]);

  // Getting curret state of School Report Sections list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.schoolReports }),
    shallowEqual
  );
  const { sectionTotalCount, sectionEntities, sectionIds, listLoading } = currentState;
  
  // School Report Sections Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    schoolReportSectionsUIProps.setIds(sectionIds);
    if (schoolReportSectionsUIProps.term) dispatch(actions.getSections(schoolReportSectionsUIProps.queryParams));
    return () => dispatch(actions.cleanReportSectionsState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectionIds, schoolReportSectionsUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "gradeLevelName",
      text: "Sınıf Düzeyi",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "grade",
      text: "Sınıf",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "name",
      text: "Şube",
      sort: true,
      sortCaret: sortCaret
    },
    {
      dataField: "courseName",
      text: "Ders",
      sort: true,
      sortCaret: sortCaret,
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: sectionTotalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: schoolReportSectionsUIProps.queryParams.pageSize,
    page: schoolReportSectionsUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={sectionEntities ?? []}
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                schoolReportSectionsUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities: sectionEntities,
                ids: schoolReportSectionsUIProps.ids,
                setIds: schoolReportSectionsUIProps.setIds
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={sectionEntities} />
              <NoRecordsFoundMessage entities={sectionEntities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}